import styled, { css, keyframes } from 'styled-components';
import { Body2 } from 'ui/theme';

const DEFAULT_SPEED = 2000;

const scrollIn = keyframes`
    0% {
        transform: translateY(100%);
    }
    10%{
        transform: translateY(0%);
    }
`;

const scrollOut = keyframes`    
    90% {
        transform: translateY(0%);
    }
    100% {
        transform: translateY(-100%);
    }
`;

const cycleText = (idx: number, rotations: number) => {
  const percentage = (idx / rotations) * 100;
  const nextPercentage = ((idx + 1) / rotations) * 100;
  return keyframes`
    0%, ${percentage - 1}%  {
        visibility: hidden;
    }
    ${percentage}%, ${nextPercentage}% {
        visibility: visible;
    }
    ${nextPercentage + 1}%, 100% {
        visibility: hidden;
    }
    `;
};

const TextContent = styled.div<{
  idx: number;
  rotations: number;
  duration: number;
}>`
  ${({ duration, idx, rotations }) =>
    css`
      animation: ${cycleText(idx, rotations)} ease-out ${rotations * duration}ms infinite;
    `};
  position: absolute;
  height: 100%;
  top: 0;
`;

const TextWrapper = styled.div<{ duration: number }>`
  ${({ duration }) =>
    css`
      animation: ${scrollIn} ease-in ${duration}ms infinite,
        ${scrollOut} ease-out ${duration}ms infinite;
    `};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const ScrollingTextContainer = styled.div`
  overflow: hidden;
  position: relative;
`;

const HiddenText = styled.div`
  visibility: hidden;
`;

export const ScrollingText = ({
  scrollingText = [],
  TextCmp = Body2,
  duration = DEFAULT_SPEED,
}: {
  scrollingText: string[];
  duration?: number;
  TextCmp?: any;
}) => {
  return (
    <ScrollingTextContainer>
      <HiddenText>
        {/* Use hidden text to set the container height  */}
        <TextCmp>{scrollingText[0]}</TextCmp>
      </HiddenText>
      <TextWrapper duration={duration}>
        {scrollingText.map((t, idx) => (
          <TextContent key={t} idx={idx} rotations={scrollingText.length} duration={duration}>
            <TextCmp>{t}</TextCmp>
          </TextContent>
        ))}
      </TextWrapper>
    </ScrollingTextContainer>
  );
};
